/**
 * Created by lzy 19-11-03
 * 百家号新建稿件
 */
'use strict';
angular.module('editBaijiahaoToBeCompiledAtlasModule', []).controller('editingCenterBaijiahaoAtlasCtrl', [
    '$scope',
    'beforeonload',
    '$element',
    '$compile',
    '$q',
    '$state',
    '$validation',
    '$timeout',
    'trsHttpService',
    'modalDialog',
    'jsonArrayToStringService',
    'editingCenterService',
    'storageListenerService',
    'ueditorService',
    'editIsLock',
    'iWoService',
    'editPictureService',
    'globleParamsSet',
    'baijiahaoService',
    'editingMediatype',
    'newMediaService',
    'baijiaConst',
    'messagePublishService',
    function (
        $scope,
        beforeonload,
        $element,
        $compile,
        $q,
        $state,
        $validation,
        $timeout,
        trsHttpService,
        modalDialog,
        jsonArrayToStringService,
        editingCenterService,
        storageListenerService,
        ueditorService,
        editIsLock,
        iWoService,
        editPictureService,
        globleParamsSet,
        baijiahaoService,
        editingMediatype,
        newMediaService,
        baijiaConst,
        messagePublishService
    ) {
        initStatus();
        initData();
        baijiahaoService.addFuture($scope, ['sendmessage']);
        editingCenterService.disabledDndDropOnOutlist($scope);
        
        /**
         * [initStatus description]初始化状态
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                support: {
                    content: ''
                },
                trillFormError: [],
                switch: 'manuscriptInfo',
                isOriginal: $state.params.isOriginal,
                progressss: 0,
                topAttachFilePicSize: '235,100',
                isFusionEditor: $state.current.name == 'fusionatlas', // 是否来自融合编辑器
                isEditDraft: !!$state.params.baijiahaoarticleid,
                baijiahaoarticleid: $state.params.baijiahaoarticleid,
                isawaitrevise: !!$state.params.isawaitrevise, // 是否待修订
                mediaType: editingMediatype.baijiahao
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.data = {
                uploaderImgSelected: [],
                PICTURES: [],
                scaleImgSize: globleParamsSet.scaleImgSize(),
                trench: baijiaConst.listenStroageKey,
                copyVersion: [],
            };
            $scope.editFlag = {
                media: 'baijiahao', 
                docType: 'atlas',
            };
        }

        /** **************************适应融合编辑器切换渠道开始**************************/
        /**
         * [initData description]初始化数据
         *
         * @param   {[type]}  dealWithListFun  [dealWithListFun description]传入方法
         *
         * @return  {[type]}                   [return description]
         */
        $scope.initData = function (dealWithListFun) {
            var defer = $q.defer();
            if (angular.isDefined($state.params.baijiahaoarticleid)) {
                initEditData(dealWithListFun).then(function () {
                    defer.resolve();
                });
            } else {
                initNewData(dealWithListFun).then(function () {
                    defer.resolve();
                });
            }
            return defer.promise;
        };

        /** **************************适应融合编辑器切换渠道结束**************************/
        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            if (!$scope.status.isFusionEditor) {
                initArrayBtn();
                ($state.params.baijiahaoarticleid ? initEditData() : initNewData()).then(function () {
                    beforeonload.beforeonloadAlert($scope);
                });
            }
            $scope.handleBtnClick = function (funname) {
                eval('$scope.' + funname + '()');
            };
            emitCloseWindow();
        }

        /**
         * [initNewData description]初始化新稿件
         *
         * @param   {[type]}  dealWithListFun  [dealWithListFun description]传入方法
         *
         * @return {[type]} [description]
         */
        function initNewData(dealWithListFun) {
            var defer = $q.defer();
            $scope.list = {
                serviceid: 'mlf_baijiahao',
                methodName: 'save',
                BAIJIAHAOARTICLEID: $state.params.baijiahaoarticleid || 0,
                // BAIJIAHAOACCOUNTID: $state.params.baijiahaoaccount,
                ACCOUNTID: $state.params.baijiahaoaccount,
                TITLE: '',
                DOCTYPEID: 2,
                HTMLCONTENT: '',
                FGD_EDITINFO: [],
                FGD_AUTHINFO: [{ isCreate: true }],
                PICTURELIST: [],
                ORIGINAL: 0,
                SPECIALDOC: 0,
                ISNOPAYMENT: '1'
            };
            loadDirective().then(function () {
                defer.resolve();
            });
            initDocgenre();
            // 融合编辑器下处理list
            if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                dealWithListFun();
            }
            return defer.promise;
        }

        /**
         * [initEditData description]查询以保存的稿件
         *
         * @param   {[type]}  dealWithListFun  [dealWithListFun description]传入方法
         *
         * @return {[type]} [description]
         */
        function initEditData(dealWithListFun) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_baijiahao',
                methodName: 'getBaiJiaHaoArticle',
                baiJiaHaoArticleId: $state.params.baijiahaoarticleid
            };
            // 适应融合编辑
            if ($scope.status.isFusionEditor) {
                params = {
                    serviceid: 'mlf_fusionbaijia',
                    methodname: 'getBaiJiaVirtualDoc',
                    SourceDocId: $scope.data.sourceDocId || $state.params.iwometadataid
                };
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                $scope.list = data;
                $scope.data.remarks = data.REMARKS;
                document.title = data.TITLE;
                $scope.list.serviceid = 'mlf_baijiahao';
                $scope.list.methodName = 'save';
                // $scope.data.specialDoc = $scope.list.SPECIALDOC;
                loadDirective().then(function () {
                    defer.resolve();
                });
                initDocgenre($scope.list);
                showVersion();
                // 融合编辑下处理list
                if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                    dealWithListFun();
                }
                // examineVideo(); //先检查视频
            });
            //  稿件加锁
            editIsLock.lockDraft($state.params.baijiahaoarticleid);
            return defer.promise;
        }

        /**
            * [initDocgenre description]初始化稿件体裁
         *
         * @param   {[type]}  obj  [obj description]传入方法
         *
         * @return {[type]} [description]
        */
        function initDocgenre(obj) {
            iWoService.initData().then(function (data) {
                $scope.data.docgenre = data.DocGenre;
                $scope.list.DOCGENRE = obj ? obj.DOCGENRE : angular.copy($scope.data.docgenre[0]);
            });
        }

        /**
         * [getAttachFileData description]初始化封面图
         *
         * @param   {[type]}  picData  [picData description]
         * @param   {[type]}  picType  [picType description]
         *
         * @return  {[type]}           [return description]
         */
        function getAttachFileData(picData, picType) {
            return [
                {
                    APPFILE: picData.imgName || picData.APPFILE,
                    APPDESC: picData.imgName || picData.APPDESC,
                    PERPICURL: picData.imgSrc || picData.PERPICURL,
                    TOPPIC: picType
                }
            ];
        }

        /**
         * [getPropagandaReview description]获取宣传部评审流程
         *
         * @return  {[type]}  [return description]
         */
        function getPropagandaReview() {
            var deffer = $q.defer();
            editingCenterService.getPropagandaReview($scope.status.mediaType, $state.params.baijiahaoarticleid).then(function (data) {
                $scope.data.propagandaReview = data;
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [getPicDataInit description]获取头条封面
         *
         * @param   {[type]}  picData  [picData description]
         *
         * @return  {[type]}           [return description]
         */
        function getPicDataInit(picData) {
            if ($scope.list.TOPATTACHFILE.length === 0) {
                $scope.list.TOPATTACHFILE = getAttachFileData(picData, '1');
            }
        }

        /**
         * [picCallbackData description] 点击获取封面图的回调
         * @return {[type]} [description]
         */
        $scope.picCallbackData = function () {
            var picresize;
            if ($scope.list.TOPATTACHFILE.length === 1) {
                modalDialog.alertType('列表图已填充满', '', 'warning', false);
                return;
            }
            if ($scope.list.TOPATTACHFILE.length === 0) {
                picresize = $scope.status.topAttachFilePicSize;
            }
            return function (fileName) {
                editPictureService.newCropperApp(fileName, picresize).then(
                    function (src) {
                        getPicDataInit(src);
                    }
                );
            };
        };

        /**
         * [loadDirective description]动态加载指令
         *
         * @return  {[type]}  [return description]
         */
        function loadDirective() {
            var defer = $q.defer();
            editingCenterService.loadManuscriptType($scope, $element); // 加载稿件原创部分
            LazyLoad.js(['./lib/ueditor2/ueditor.config.js?v=11.5', './lib/ueditor2/ueditor.all.js?v=11.8'], function () {
                var $ueditor = $('<ueditor-for-atlas edit-flag="editFlag" list="list" class="newEditor"></ueditor-for-atlas>');
                $element.find('ueditorLocation').append($ueditor);
                $ueditor = $compile($ueditor)($scope);
                var ue = UE.getEditor('ueditor');
                $scope.status.support.content = $scope.list.CONTENT;
                ue.ready(function () {
                    messagePublishService.publish('ueReady');
                    ue.addListener('keydown', function (type, event) {
                        if (event.keyCode === 13) {
                            $scope.status.support.content = ue.getContentTxt();
                        }
                    });
                    defer.resolve();
                });
                if (!$scope.status.isFusionEditor) {
                    // 非融合编辑下的加载发稿单
                    var draftList =
                        '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="bjhAtlasForm"></editor-dir>' +
                        '<editor-auth-dir author="list.FGD_AUTHINFO"></editor-auth-dir>';
                    draftList = $compile(draftList)($scope);
                    $element.find('editor').append(draftList);
                }
            });
            return defer.promise;
        }

        /**
         * [loadFgd description]加载发稿单
         *
         * @return  {[type]}  [return description]
         */
        $scope.loadFgd = function () {
            var draftList =
                '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="bjhAtlasForm"></editor-dir>' +
                '<editor-auth-dir author="list.FGD_AUTHINFO" originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0"></editor-auth-dir>';
            draftList = $compile(draftList)($scope);
            $element.find('editor').append(draftList);
        };

        /* ------------------------- 图集上传图片开始 ------------------------- */
        $scope.moveUploadImg = function (index) {
            $scope.list.PICTURELIST.splice(index, 1);
        };

        /* 批量上传图片模态框*/
        $scope.multiImgsUploader = function () {
            // 对接媒资库
            let options = {
                resourceType: '0',
                isMulti: true
            };
            editingCenterService.mediaSelector(options).then(function(result) {
                var picList = [];
                for (var l = 0; l < result.list.length; l++) {
                    // 我的图片已经选中的
                    var imgName = result.list[l].previewurl.substring(result.list[l].previewurl.lastIndexOf('\/') + 1).split('?')[0];
                    picList.push({
                        PERPICURL: result.list[l].resourceurl,
                        APPFILE: imgName,
                        APPDESC: result.list[l].resourcetitle,
                        APPSIZE: result.list[l].resourcesize,
                        meiziId: result.list[l].resourceid,
                        relationId: result.list[l].relationid
                    });
                }
                $scope.list.PICTURELIST = $scope.list.PICTURELIST.concat(picList);
            });
        };
        // 批量删除列表图片
        $scope.batchDelete = function () {
            modalDialog.confirmModal('删除', '是否确认删除选择的图片', function () {
                var temp = [];
                angular.forEach($scope.list.PICTURELIST, function (value, key) {
                    if ($scope.data.uploaderImgSelected.indexOf(value) < 0) {
                        temp.push(value);
                    }
                });
                $scope.list.PICTURELIST = temp;
                $scope.data.uploaderImgSelected = [];
            });
        };

        /**
     * [multiImgsDownload description] 下载原图
     * @return {[type]} [description]
     */
        $scope.multiImgsDownload = function () {
            $scope.loadingPromise = editingCenterService.downloadOrgImgList($scope.data.uploaderImgSelected, 'PERPICURL', 'APPDESC');
        };
        // 列表图片单选
        $scope.selectImg = function (item) {
            if ($scope.data.uploaderImgSelected.indexOf(item) < 0) {
                $scope.data.uploaderImgSelected.push(item);
            } else {
                $scope.data.uploaderImgSelected.splice($scope.data.uploaderImgSelected.indexOf(item), 1);
            }
        };
        // 列表图片全选
        $scope.selectAllImg = function () {
            $scope.data.uploaderImgSelected = $scope.data.uploaderImgSelected.length === $scope.list.PICTURELIST.length ? [] : [].concat($scope.list.PICTURELIST);
        };
        // 图片上移开始
        $scope.upMove = function (index) {
            if (index !== 0) {
                swapItems($scope.list.PICTURELIST, index, index - 1);
            }
        };
        // 图片下移开始
        $scope.downMove = function (index) {
            if (index !== $scope.list.PICTURELIST.length - 1) {
                swapItems($scope.list.PICTURELIST, index, index + 1);
            }
        };

        /**
         * [swapItems description]
         *
         * @param   {[type]}  list    [list description]
         * @param   {[type]}  index1  [index1 description]
         * @param   {[type]}  index2  [index2 description]
         *
         * @return  {[type]}          [return description]
         */
        function swapItems(list, index1, index2) {
            list[index1] = list.splice(index2, 1, list[index1])[0];
        }

        /**
         * [editImage description]编辑图片
         *
         * @param   {[type]}  image  [image description]
         * @param   {[type]}  index  [index description]
         *
         * @return  {[type]}         [return description]
         */
        $scope.editImage = function (image, index) {
            // editingCenterService.editUploaderImg(image, function (result) {
            //     $scope.list.PICTURELIST[index].PERPICURL = result.PERPICURL;
            //     $scope.list.PICTURELIST[index].APPFILE = result.APPFILE;
            //     $scope.list.PICTURELIST[index].APPDESC = result.APPDESC;
            //     delete $scope.list.PICTURELIST[index].APPENDIXID;
            // });
            // 对接媒资库
            let options = {
                resourceType: '0',
                isMulti: false
            };
            editingCenterService.mediaSelector(options).then(function(result) {
                var imgName = result.list[0].previewurl.substring(result.list[0].previewurl.lastIndexOf('\/') + 1).split('?')[0];
                $scope.list.PICTURELIST[index] = {
                    PERPICURL: result.list[0].resourceurl,
                    APPFILE: imgName,
                    APPDESC: result.list[0].resourcetitle,
                    APPSIZE: result.list[0].resourcesize,
                    meiziId: result.list[0].resourceid,
                    relationId: result.list[0].relationid
                };
            });
        };
        // 图片单个删除
        $scope.deleteImg = function (index) {
            modalDialog.confirmModal('删除', '确定删除？', function () {
                var temp = [];
                for (var i = 0; i < $scope.list.PICTURELIST.length; i++) {
                    if (i != index) {
                        temp.push($scope.list.PICTURELIST[i]);
                    }
                }
                $scope.list.PICTURELIST = temp;
                // $scope.list.PICTURES.splice(index, 1);
            });
        };
        $scope.photoCrop = function (image, index) {
            editPictureService.editPicture(angular.copy(image), $state.params.wzsiteid, function (img) {
                $scope.list.PICTURELIST[index].APPFILE = img.imgName;
                $scope.list.PICTURELIST[index].PERPICURL = img.imgSrc;
                $scope.list.PICTURELIST[index].SRCFILE = img.srcFile;
                delete $scope.list.PICTURELIST[index].APPENDIXID;
            });
        };
        // 说明引用到所有
        $scope.declareAll = function (index) {
            modalDialog.confirmModal('同步', '确定同步该说明到其它图片？', function () {
                angular.forEach($scope.list.PICTURELIST, function (data, key) {
                    $scope.list.PICTURELIST[key].APPDESC = $scope.list.PICTURELIST[index].APPDESC;
                });
            });
        };

        /* ------------------------- 图集上传图片结束 ------------------------- */
        /**
        * [save description] 保存稿件
        * @param {[type]} [flag] [description] 是否为操作前的保存
        * @return {[type]} [description]
        */
        $scope.save = function (flag) {
            var defer = $q.defer();
            saveList(true).then(
                function (data) {
                    // 保存成功后的处理
                    storageListenerService.addListenerToBaijiahao('save');
                    $scope.status.isEditDraft = true;
                    $state.transitionTo($state.current, $state.params, {
                        reload: false
                    });
                    showVersion();
                    // 保存
                    if (!$scope.status.isFusionEditor) {
                        $timeout(function () {
                            modalDialog.saveModel('保存成功', '', 'success');
                        }, 500);
                    }
                    defer.resolve(data);
                },
                function (msg) {
                    // modalDialog.alertType('保存失败', '', 'warning', false);
                    defer.reject(msg);
                }
            );
            return defer.promise;
        };

        /**
         * [saveList description]切换时保存list数据
         *
         * @param   {[type]}  flag  [flag description] 判断是否进行加锁操作，如果关闭页面则不加锁，不关闭则加锁
         *
         * @return  {[type]}        [return description]
         */
        function saveList(flag) {
            var defer = $q.defer();
            // 处理发稿单作者信息空数据提交问题
            if ($scope.status.isFusionEditor) {
                $scope.list.serviceid = 'mlf_fusionbaijia';
                $scope.list.methodName = 'saveBaiJiaVirtualDoc';
                $scope.list.SourceDocId = $scope.data.sourceDocId || $state.params.baijiahaoarticleid;
                $scope.list.FusionBaiJiaId = $state.params.baijiahaoarticleid || '0';
            }
            ueditorService.saveContent($scope.list);
            $scope.bjhAtlasForm.$pending = {};
            $validation
                .validate($scope.bjhAtlasForm)
                .success(function () {
                    modalDialog.isSecretInformation(
                        true,
                        function () {
                            var list = angular.copy($scope.list);
                            if (list.PICTURELIST.length < 4) {
                                modalDialog.alertType('保存失败', '图集稿图集不得少于四张图片', 'error', 'confirm', '', () => {

                                }, () => { }, '', '我知道了');
                                defer.reject({
                                    plat: '百家号'
                                });
                                return defer.promise;            
                            }
                            list.ORIGINALTYPE = $scope.data.originType;
                            list.SPECIALDOC = $scope.data.specialDoc;
                            list.BAIJIAHAOARTICLEID = $state.params.baijiahaoarticleid || '0';
                            list.DOC_PICTURELIST = list.PICTURELIST; // PICTURELIST是做新媒体渠道时添加的，为了兼容性，需把两边的值保持一致
                            list = jsonArrayToStringService.jsonArrayToString(list);
                            $scope.bjhAtlasForm.$setPristine();
                            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(function (data) {
                                $state.params.baijiahaoarticleid = $scope.list.baijiahaoarticleid = data.METADATAID.replace(/\"/g, ''); // 后台返回的是字符串，需要转成数字类型
                                beforeonload.refresh($scope);
                                //  稿件加锁
                                if (flag) {
                                    editIsLock.lockDraft($state.params.baijiahaoarticleid);
                                }
                                $state.params.baijiahaoarticleid = data.METADATAID.replace(/\"/g, '');
                                defer.resolve(data);
                            });
                        },
                        function () {
                            defer.reject();
                        }
                    );
                })
                .error(function () {
                    editingCenterService.checkSaveError($scope.bjhAtlasForm, $element, $scope);
                    defer.reject({
                        plat: '百家号'
                    });
                });
            return defer.promise;
        }

        /**
         * [initArrayBtn description]初始化按钮
         * @return {[type]} [description]
         */
        function initArrayBtn() {
            baijiahaoService.initEditerBtn($state.params.baijiahaoplatform, $state.params.baijiahaoaccount).then(function(data) {
                $scope.arrayBtn = data;
            });
        }

        /**
     * [baijiahaoTrial description]送审操作
     * @return {[type]} [description]
     */
        $scope.baijiahaoTrial = function () {
            newMediaService.trial($scope, baijiaConst.trial).then((opinion) => {
                saveList().then(function () {
                    let baijiaParams = angular.extend({
                        baiJiaHaoArticleIds: $state.params.baijiahaoarticleid, accountId: $state.params.baijiahaoaccount,
                        opinion: opinion
                    }, baijiaConst.trial);
                    messagePublishService.publish('doEditPageOperation', baijiaParams);
                });
            });
        };

        /**
         * [baijiahaoSign description]签发操作
         * @return {[type]} [description]
         */
        $scope.baijiahaoSign = function () {
            $scope.loadingPromise = newMediaService.sign($scope, baijiaConst.sign).then(() => {
                saveList().then(() => {
                    let signParams = angular.extend({
                        baiJiaHaoArticleId: $state.params.baijiahaoarticleid,
                        accountId: $state.params.baijiahaoaccount,
                    }, baijiaConst.sign);
                    messagePublishService.publish('doEditPageOperation', signParams);
                });
            });
        };

        /**
         * [baijiahaoKill description]撤稿操作
         *
         * @return  {[type]}  [return description]
         */
        $scope.baijiahaoKill = function () {
            newMediaService.rejection($scope, baijiaConst.drawNews).then((opinion) => {
                saveList().then(function () {
                    let baijiaParams = angular.extend(
                        {
                            baiJiaHaoArticleIds: $state.params.baijiahaoarticleid,
                            accountId: $state.params.account,
                            opinion: opinion
                        },
                        baijiaConst.drawNews
                    );
                    messagePublishService.publish('doEditPageOperation', baijiaParams);
                });
            });
        };


        /**
         * [multiImgsWatermark description]一键水印
         *
         * @return  {[type]}  [return description]
         */
        $scope.multiImgsWatermark = function () {
            $scope.loadingPromise = editingCenterService.multiImgsWatermark($scope.data.uploaderImgSelected, $state.params.appsiteid, $state.params.baijiahaoaccount, $scope.status.mediaType).then((response) => {
                for (var i = 0; i < $scope.list.PICTURELIST.length; i++) {
                    if (response.LIST[$scope.list.PICTURELIST[i].APPFILE]) {
                        $scope.list.PICTURELIST[i].PERPICURL = response.LIST[$scope.list.PICTURELIST[i].APPFILE].FILEURL;
                        $scope.list.PICTURELIST[i].APPFILE = response.LIST[$scope.list.PICTURELIST[i].APPFILE].FILENAME;
                        $scope.list.PICTURELIST[i].APPENDIXID = 0;
                    }
                }
            });
        };

        /**
         * [updateCKSelection description]更新稿费状态
         * @param  {[obj]} list [description]稿件对象
         * @return {[type]}     [description]
         */
        $scope.updateCKSelection = function (list) {
            list.ISNOPAYMENT = list.ISNOPAYMENT === '1' ? '0' : '1';
        };

        /**
     * [theFormError description] 获取表单变化
     * @return {[type]} [description]
     */
        $scope.theFormError = function () {
            // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.bjhAtlasForm.$error) {
                errorArray.push(error);
            }
            $scope.status.videoFormError = $scope.status.videoFormError == undefined ? [] : $scope.status.videoFormError;
            if ($scope.status.videoFormError.length != errorArray.length) {
                // 长度不相等说明表单errorname发生变化
                $scope.status.videoFormError = errorArray;
            }
            return $scope.status.videoFormError; // 返回
        };

        /**
         * [revise description] 修订操作
         * @return  {[type]}  [return description]
         */
        $scope.revise = function () {
            modalDialog.confirmModal('修订', '确认修订?', function () {
                saveList().then(function () {
                    var params = {
                        MediaType: $scope.status.mediaType
                    };
                    $scope.loadingPromise = editingCenterService.reviseFinished(params);
                });
            });
        };

        /**
         * [showVersion description] 判断是融合编辑下的获取版本记录还是渠道内的获取版本记录
         * @return  {[type]}  [return description]
         */
        function showVersion() {
            if ($scope.status.isFusionEditor) {
                getFusionVersion();
            } else {
                getVersion();
                getPropagandaReview();
            }
        }

        /**
         * [getVersion description] 获取流程记录
         * @return  {[type]}  [return description]
         */
        function getVersion() {
            newMediaService.getVersion($scope.status.mediaType, $state.params.baijiahaoarticleid).then(function (data) {
                $scope.data.records = data;
            });
        }

        /**
         * [getVersion description] 获取融合编辑流程记录
         * @return {[type]} [description]
         */
        function getFusionVersion() {
            var deffer = $q.defer();
            editingCenterService.getEditVersionTime(
                $scope.data.sourceDocId || $state.params.iwometadataid,
                $scope.page,
                $scope.data.copyVersion
            ).then(function (data) {
                $scope.data.version = data;
                $scope.page = data.page;
                $scope.data.copyVersion = data.copyArray;
                $scope.status.hasVersionTime = true;
                $scope.data.lastVersionid = data.lastVersionid;
                deffer.resolve();
            },
            function () {
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [getLoadMore description]操作日志加载更多
         * @return {[type]} [description]
         */
        $scope.getLoadMore = function () {
            $scope.page.CURRPAGE++;
            getFusionVersion();
        };

        /**
         * [openPersonalVersionTime description] 打开流程版本详情页
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.openPersonalVersionTime = function (item) {
            newMediaService.openPersonalVersionTime($state.params.iwometadataid, item);
        };

        /**
         * [closeCurrView description] 页面关闭
         * @return  {[type]}  [return description]
         */
        $scope.closeCurrView = function() {
            baijiahaoService.baijiahaoUnlock($scope.bjhAtlasForm, $scope.list, saveList, $state.params.baijiahaoarticleid);
        };

        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            // window.onbeforeunload = function() {
            //     if ($state.params.baijiahaoarticleid) {
            //         localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $state.params.baijiahaoarticleid }));
            //     }
            // };
            editingCenterService.allAppCloseWindow($scope, {typeName: 'baijiahao', saveLocal: false});
        }
    }
]);
